// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
import FitTextToBounds from "../core/components/FitTextToBounds";
import LocaliseText from "../core/components/LocaliseText";
import EarnedPointsTotal from "./EarnedPointsTotal";
import BtnLevelSelect from "./BtnLevelSelect";
import BtnReplayEnd from "../core/prefabs/BtnReplayEnd";
import BtnNextLevel from "./BtnNextLevel";
/* START-USER-IMPORTS */
import { app } from '../core/App';
import { TransitionPoint } from '../app-routing';
import UIButton from '../core/components/UIButton';
import GameUI from '../scenes/GameUI';
import { GameDataHandler } from '../GameDataHandler';
import { Character, CharacterNameValues } from '../Character';
import { RunSettingsHandler } from './../level/RunSettingsHandler';
import { LevelNameValues } from "../level/levels/level";
/* END-USER-IMPORTS */

export default class EndScreen extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 960, y ?? 384);

    // cover
    const cover = scene.add.rectangle(0, 0, 1920, 768);
    cover.visible = false;
    cover.isFilled = true;
    cover.fillColor = 0;
    cover.fillAlpha = 0.6;
    this.add(cover);

    // screen
    const screen = scene.add.container(0, -106);
    this.add(screen);

    // panel
    const panel = scene.add.image(0, 57, "game", "popup-endscreen.png");
    screen.add(panel);

    // bestScoreBox
    const bestScoreBox = scene.add.image(125, 165, "common", "box.png");
    screen.add(bestScoreBox);

    // scoreBox
    const scoreBox = scene.add.image(-125, 165, "common", "box.png");
    screen.add(scoreBox);

    // iconBestScore
    const iconBestScore = scene.add.image(125, 43, "common", "trophy.png");
    screen.add(iconBestScore);

    // iconScore
    const iconScore = scene.add.image(-125, 49, "common", "icon-note-pile.png");
    screen.add(iconScore);

    // bestScoreText
    const bestScoreText = scene.add.text(125, 170, "", {});
    bestScoreText.setOrigin(0.5, 0.5);
    bestScoreText.text = "0";
    bestScoreText.setStyle({ "fontFamily": "FREDFREDBURGER-BOLD", "fontSize": "70px" });
    bestScoreText.setPadding({"right":7});
    screen.add(bestScoreText);

    // endScoreText
    const endScoreText = scene.add.text(-125, 170, "", {});
    endScoreText.setOrigin(0.5, 0.5);
    endScoreText.text = "0";
    endScoreText.setStyle({ "fontFamily": "FREDFREDBURGER-BOLD", "fontSize": "70px" });
    endScoreText.setPadding({"right":7});
    screen.add(endScoreText);

    // endText
    const endText = scene.add.text(0, -70, "", {});
    endText.setOrigin(0.5, 0.5);
    endText.text = "Well done!";
    endText.setStyle({ "align": "center", "color": "#ffffffff", "fontFamily": "FREDFREDBURGER-BOLD", "fontSize": "70px" });
    endText.setPadding({"right":7});
    screen.add(endText);

    // earnedPointsTotal
    const earnedPointsTotal = new EarnedPointsTotal(scene, 0, -186);
    earnedPointsTotal.visible = false;
    screen.add(earnedPointsTotal);

    // character
    const character = scene.add.image(-451, 262, "endscreen", "character-jerry.png");
    this.add(character);

    // btnLevelSelectEnd
    const btnLevelSelectEnd = new BtnLevelSelect(scene, -200, 265);
    this.add(btnLevelSelectEnd);

    // btnReplayEnd
    const btnReplayEnd = new BtnReplayEnd(scene, 0, 265);
    this.add(btnReplayEnd);

    // btnNextLevel
    const btnNextLevel = new BtnNextLevel(scene, 200, 265);
    this.add(btnNextLevel);

    // endText (components)
    const endTextFitTextToBounds = new FitTextToBounds(endText);
    endTextFitTextToBounds.maxWidth = 650;
    endTextFitTextToBounds.maxHeight = 80;
    endTextFitTextToBounds.minFontSize = 20;
    endTextFitTextToBounds.constrainByWidth = true;
    endTextFitTextToBounds.constrainByHeight = true;
    const endTextLocaliseText = new LocaliseText(endText);
    endTextLocaliseText.copyId = "wellDone";

    // earnedPointsTotal (prefab fields)
    earnedPointsTotal.showLiveTotal = false;

    this.cover = cover;
    this.screen = screen;
    this.panel = panel;
    this.bestScoreBox = bestScoreBox;
    this.scoreBox = scoreBox;
    this.iconBestScore = iconBestScore;
    this.iconScore = iconScore;
    this.bestScoreText = bestScoreText;
    this.endScoreText = endScoreText;
    this.endText = endText;
    this.earnedPointsTotal = earnedPointsTotal;
    this.character = character;
    this.btnLevelSelectEnd = btnLevelSelectEnd;
    this.btnReplayEnd = btnReplayEnd;
    this.btnNextLevel = btnNextLevel;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    this.newHighScore = false;
    this.isPurchasable = false;
    /* END-USER-CTR-CODE */
  }

  private cover: Phaser.GameObjects.Rectangle;
  private screen: Phaser.GameObjects.Container;
  private panel: Phaser.GameObjects.Image;
  private bestScoreBox: Phaser.GameObjects.Image;
  private scoreBox: Phaser.GameObjects.Image;
  private iconBestScore: Phaser.GameObjects.Image;
  private iconScore: Phaser.GameObjects.Image;
  private bestScoreText: Phaser.GameObjects.Text;
  private endScoreText: Phaser.GameObjects.Text;
  private endText: Phaser.GameObjects.Text;
  private earnedPointsTotal: EarnedPointsTotal;
  private character: Phaser.GameObjects.Image;
  private btnLevelSelectEnd: BtnLevelSelect;
  private btnReplayEnd: BtnReplayEnd;
  private btnNextLevel: BtnNextLevel;
  public screenStartY: number = 700;
  public characterStartY: number = 1300;

  /* START-USER-CODE */
  private particles!: Phaser.GameObjects.Particles.ParticleEmitterManager;
  private endScore!: number;
  private highScore!: number;
  private earnedPoints!: number;
  private newHighScore: boolean;

  private charStartX: number = 0;
  private charStartY: number = 0;
  private twoBtnSpacing = 120;
  private nextLevel: LevelNameValues | undefined;
  private nextNextLevel: LevelNameValues | undefined;
  private nextLevelPrice: number | undefined;
  private isPurchasable: boolean;

  public awake() {
    this.cover.setInteractive();

    this.btnLevelSelectEnd.once(UIButton.events.clicked, () => {
      this.scene.events.emit(GameUI.events.LevelSelect);
    });

    this.btnReplayEnd.once(UIButton.events.clicked, () => {
      this.scene.events.emit(GameUI.events.Replay);
    });

    this.btnNextLevel.once(UIButton.events.clicked, () => {
      if (!this.nextLevel) return;

      if (this.nextLevelPrice) {
//        GameDataHandler.spendEarnedPoints(this.scene, this.nextLevelPrice);

//        GameDataHandler.purchaseLevel(this.scene, this.nextLevel);

        // We need to unlock the next next level.


        //this.earnedPointsTotal.tickToNewTotal(this.earnedPoints + this.endScore - this.nextLevelPrice, 750, 0);

//        this.btnNextLevel.onPurchase(750, () => {
//          this.scene.events.emit(GameUI.events.NextLevel, this.nextLevel);
//        })
//      } else {
        this.scene.events.emit(GameUI.events.NextLevel, this.nextLevel);
      }
    });

    // let line = new Phaser.Geom.Line(-960, -400, 1920, -300);
    this.particles = this.scene.make.particles(
      {
        key: 'common',
        emitters: [
          {
            name: 'explode',
            //frame: ['confetti.png'],
            on: false,
            frame: ['icon-note.png'],
            // x: -960,
            // y: -400,
            angle: { min: -200, max: 0 },
            //scale: { min: 0.5, max: 2.0 },
            rotate: { min: 0, max: 360 },
            scale: { start: 0.8, end: 2, ease: Phaser.Math.Easing.Cubic.Out },
            alpha: { start: 1, end: 0, ease: Phaser.Math.Easing.Cubic.In },
            speed: { min: 400, max: 900 },
            gravityY: 400,
            lifespan: 5000,
            quantity: 1
            //emitZone: { source: new Phaser.Geom.Circle(0,0,200) }
          }
        ]
      },
      false
    );
    this.add(this.particles);
  }

  public activate(endScore: number, highScore: number, earnedPoints: number, char: CharacterNameValues) {
    this.character.setFrame('character-' + char + '.png');

    this.charStartX = this.character.x;
    this.charStartY = this.character.y;
    this.character.y += 800;
    this.character.scale = 0.5;

    this.endScore = Math.trunc(endScore);
    this.highScore = Math.trunc(highScore);
    this.earnedPoints = earnedPoints;
    this.earnedPointsTotal.setTotal(earnedPoints);

    this.newHighScore = false;
    if (this.endScore > this.highScore || this.highScore == 0) this.newHighScore = true;

    this.bestScoreText.setText(this.highScore.toString());

    // Check if we show next level btn.
    let currentLevel: LevelNameValues = RunSettingsHandler.getSelectedLevel(this.scene);
    let nextLevelDetails = RunSettingsHandler.getNextLevelDetails(this.scene, currentLevel);
    this.nextLevel = nextLevelDetails.nextLevel;
    this.nextLevelPrice = nextLevelDetails.nextLevelPrice;
    this.isPurchasable = this.nextLevel != null && this.nextLevelPrice != null && !GameDataHandler.isLevelPurchased(this.scene, this.nextLevel);

    if(this.nextLevel)
    {
      GameDataHandler.unlockLevel(this.scene, this.nextLevel);

      /*if (this.nextLevelPrice && this.isPurchasable) {
        // Check if we can afford it.
        if (GameDataHandler.canPurchase(this.scene, this.nextLevelPrice)) this.btnNextLevel.showUnlockCost(this.nextLevelPrice);
        else this.hideNextLevelBtn();

      } else {*/
        this.btnNextLevel.hideUnlockCost();
      //}
    } else {
      this.hideNextLevelBtn();
    }

    this.transitionIn();
  }

  protected hideNextLevelBtn() {
    this.btnNextLevel.visible = false;
    this.btnLevelSelectEnd.x = -this.twoBtnSpacing;
    this.btnReplayEnd.x = this.twoBtnSpacing;
  }

  protected transitionIn() {
    let startDelay = 900;

    this.cover.alpha = 0;
    this.scene.add.tween({
      targets: this.cover,
      alpha: { from: 0, to: 1 },
      duration: 500,
      delay: startDelay,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    let screenFinishY = this.screen.y;
    this.screen.y = this.screenStartY;
    this.scene.add.tween({
      targets: this.screen,
      y: { from: this.screenStartY, to: screenFinishY },
      duration: 600,
      ease: Phaser.Math.Easing.Back.Out,
      delay: startDelay + 750
    });

    this.scene.add.tween({
      targets: this.character,
      scale: 1,
      x: this.charStartX,
      y: this.charStartY,
      duration: 500,
      delay: startDelay,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    this.scene.time.delayedCall(startDelay + 1100, () => {
      app.audioHandler.playSound(this.scene, 'SndPickup', 'sfx');
      app.audioHandler.playSound(this.scene, 'SndPickup2', 'sfx');
      let emitter = this.particles.emitters.getByName('explode');
      emitter?.explode(40, 0, -120);
      this.scene.children.bringToTop(this.particles);
    });

    /*this.scene.time.delayedCall(250, () => {
      let emitter = this.particles.emitters.getByName('fireworks');
      emitter?.explode(200, 400, -100);
    });

    this.scene.time.delayedCall(500, () => {
      let emitter = this.particles.emitters.getByName('fireworks');
      emitter?.explode(200, -150, 200);
    });*/

    let characterDelay = 0;

    this.iconScore.alpha = 0;
    this.endScoreText.alpha = 0;
    this.scene.add.tween({
      targets: [this.iconScore, this.endScoreText],
      alpha: { from: 0, to: 1 },
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.InOut,
      delay: startDelay + 2000
    });

    this.iconBestScore.alpha = 0;
    this.bestScoreText.alpha = 0;
    this.scene.add.tween({
      targets: [this.iconBestScore, this.bestScoreText],
      alpha: { from: 0, to: 1 },
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.InOut,
      delay: startDelay + 2500
    });

    let endTimeCounterTween = this.scene.tweens.addCounter({
      from: 0,
      to: this.endScore,
      duration: 2000,
      delay: startDelay + 2750,
      ease: Phaser.Math.Easing.Linear,
      onUpdate: (tween, target, param) => {
        this.endScoreText.text = Math.floor(endTimeCounterTween.getValue()).toString();
      }
    });

    this.earnedPointsTotal.tickToNewTotal(this.earnedPoints + this.endScore, 2000, startDelay + 2750);

    if (this.newHighScore) {
      let bestTimeCounterTween = this.scene.tweens.addCounter({
        from: this.highScore,
        to: this.endScore,
        duration: 2000,
        delay: startDelay + 5000,
        ease: Phaser.Math.Easing.Linear,
        onStart: () => {},
        onUpdate: (tween, target, param) => {
          this.bestScoreText.text = Math.floor(bestTimeCounterTween.getValue()).toString();
        },
        onComplete: () => {
          this.bestScoreText.setColor('#ffef00');

          this.scene.add.tween({
            targets: this.bestScoreText,
            alpha: { from: 1, to: 0 },
            duration: 500,
            ease: Phaser.Math.Easing.Cubic.InOut,
            repeat: 2,
            yoyo: true,
            delay: 250
          });
        }
      });
    }

    this.btnLevelSelectEnd.alpha = 0;
    this.btnReplayEnd.alpha = 0;
    this.btnNextLevel.alpha = 0;
    this.scene.add.tween({
      targets: [this.btnLevelSelectEnd, this.btnReplayEnd, this.btnNextLevel],
      alpha: { from: 0, to: 1 },
      y: { from: 500, to: 265 },
      duration: 500,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      delay: startDelay + 3000
    });

    this.scene.time.delayedCall(1100, this.startIdles, [], this);
  }

  protected startIdles() {}

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */
